const getFirstLetter = (text, letterCount = 2) =>
  text
    .split(/\s/)
    .slice(0, letterCount)
    .map((word) => word[0])
    .join("")
    .toUpperCase();

export default getFirstLetter;
